module.exports = __webpack_public_path__ + "static/media/springer.0cc98c42.svg";